<template>
  <div :class="$style.wrapper">
    <!-- Поиск -->
    <div :class="$style.search">
      <input
        :class="$style.searchInput"
        v-model="search"
        type="text"
        placeholder="Поиск по вопросам"
      />
      <span :class="$style.searchIcon">
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path
            d="M15.5 15.5L20 20"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
          <circle
            cx="11"
            cy="11"
            r="6"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
          />
        </svg>
      </span>
    </div>

    <!-- Список вопросов -->
    <div :class="$style.list">
      <div
        v-for="item in filteredFaqs"
        :key="item.id"
        :class="$style.card"
        :ref="`faq-${item.id}`"
      >
        <button
          type="button"
          :class="$style.cardHeader"
          @click="toggle(item.id)"
        >
          <div :class="$style.question">{{ item.title }}</div>
          <div :class="[$style.chevron, isOpen(item.id) && $style.chevronOpen]">
            <svg width="18" height="18" viewBox="0 0 24 24">
              <path
                d="M7 10l5 5 5-5"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </button>

        <transition name="faq">
          <div
            v-if="isOpen(item.id)"
            :class="$style.answer"
            v-html="item.body"
          />
        </transition>
      </div>

      <div v-if="!filteredFaqs.length" :class="$style.empty">
        Ничего не найдено
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Faq",
  data() {
    return {
      search: "",
      openedId: null,
      faqs: [
        {
          id: 1,
          title: "1. Как зарегистрироваться на Платформе",
          body: `
<p>1.1. Выберите, в качестве кого вы хотите зарегистрироваться на Платформе. Если вы хотите продавать свои товары на Платформе, зарегистрируйтесь в качестве Селлера, если хотите покупать товар для последующей перепродажи, зарегистрируйтесь как Реселлер. Ознакомьтесь и примите Правила пользования и Политику конфиденциальности Платформы. Регистрация происходит путём авторизации с помощью вашего Telegram, а также указания логина, номера телефона и адреса электронной почты в соответствии с Политикой конфиденциальности Платформы.</p>
<p>1.2. Если вы хотите зарегистрироваться, как Селлер, на этапе регистрации выберите время, за которое вы сможете доставлять ваши товары по заказам до пункта выдачи и аутентификации Платформы по адресу: Московская область, Ленинский городской округ, Варшавское шоссе, 21-й километр, с26, помещение АД 14А.</p>
<p><b>Важно:</b> Будьте внимательны. Нарушение сроков доставки ведёт к падению рейтинга Селлера на Платформе. Выбирайте время доставки исходя из ваших возможностей. Также следует помнить, что скорость доставки влияет на ваш рейтинг и будет преимуществом перед другими Селлерами при продаже товаров. При частых нарушениях сроков доставки аккаунт Селлера на Платформе может быть заблокирован.</p>
<p>1.2.1. Привяжите банковскую карту в личном кабинете для получения денег за продажу товаров.</p>
<p>1.2.2. Что делать, если я не успеваю доставить товар до пункта выдачи и аутентификации вовремя:</p>
<ul>
  <li>Вы можете запросить продление сроков доставки у Реселлера на то время, которое вам нужно.</li>
</ul>
<p><b>Важно:</b> Реселлер имеет право отказать вам в продлении срока доставки.</p>
<p>1.3. Если вы хотите зарегистрироваться как Реселлер, следуйте по шагам, которые требует Платформа.</p>
<p>1.3.1. Следуйте далее для завершения регистрации.</p>
          `,
        },
        {
          id: 2,
          title: "2. Как Селлеру продавать товар на Платформе",
          body: `
<p>2.1. Зарегистрируйтесь на Платформе как Селлер.</p>
<p>2.2. Зайдите в личный кабинет, скачайте Excel – шаблон и заполните его.</p>
<p>2.2.1. Что делать, если я не могу заполнить шаблон:</p>
<ul>
  <li>Обратитесь в службу поддержки Платформы через Личный кабинет либо добавьте товары вручную.</li>
</ul>
<p>2.3. Отправьте каталог своих товаров на публикацию на Платформе. В случае успешного прохождения модерации каталог ваших товаров будет опубликован на Платформе. В случае, если ваш каталог не пройдёт модерацию, служба поддержки свяжется с вами.</p>
<p>2.4. Как происходит процесс продажи:</p>
<p>2.4.1. Примите заявку на заказ от Реселлера в течение 60 минут с момента получения статуса «Новая заявка, подтвердите». Таймер подскажет вам, сколько времени у вас осталось на принятие или отклонение заявки.</p>
<p><b>Важно:</b> Вы можете отказаться от принятия заявки в случае, если вас не устроила предложенная Реселлером цена (если вы установили возможность торга при публикации каталога, либо по иной причине, которую вам предложит Платформа.</p>
<p>Обратите внимание, что частые отказы от принятия заявок по причинам, которые не являются ценой, предложенной Реселлером, ведут к падению рейтинга Селлера на Платформе. При частых отказах по причинам, не связанным с ценой, аккаунт Селлера на Платформе может быть заблокирован.</p>
<p>2.4.2. Дождитесь статуса «Заказ ожидает оплату».</p>
<p>2.4.3. После получения статуса «Заказ оплачен, доставьте Товар в пункт выдачи и аутентификации» доставьте ваш товар по заказу в пункт выдачи и аутентификации Платформы по адресу: Московская область, Ленинский городской округ, Варшавское шоссе, 21-й километр, с26, помещение АД 14А., в срок, указанный при регистрации на Платформе. Таймер времени подскажет вам, сколько времени у вас осталось на доставку в пункт выдачи и аутентификации.</p>
<p><b>Важно:</b> Будьте внимательны. Нарушение сроков доставки ведёт к падению рейтинга Селлера на Платформе. При частых нарушениях сроков доставки аккаунт Селлера на Платформе может быть заблокирован.</p>
<p>2.4.4. Передайте свой товар менеджеру в пункте выдачи и аутентификации. После осмотра товара на соответствие заказу и его состоянию ваш товар будет принят для дальнейшей аутентификации.</p>
<p>2.4.4.1. Как я должен убедиться, что мой товар не подменят, не потеряют и вернут в целостности, если Реселлер оформит возврат или не заберёт товар:</p>
<ul>
  <li>Все товары, поступающие в пункт выдачи и аутентификации, сопровождаются актом приёма-передачи товара. В случае, если с вашим товаром что-то случится по вине Платформы, Платформа возместит вам его стоимость, которая была указана в заказе на этот товар.</li>
</ul>
<p>2.4.5. Дождитесь статуса «Заказ готов к выдаче». Это значит, что ваш товар прошёл аутентификацию и готов к выдаче Реселлеру.</p>
<p>2.4.6. У Реселлера будет 48 часов с момента готовности заказа к выдаче, чтобы получить его в пункте выдачи и аутентификации, а также вернуть его, если потребуется.</p>
<p><b>Важно:</b> Реселлер может отказаться от получения товара по заказу после того, как заказу присвоится статус «Заказ готов к выдаче».</p>
<p>2.4.7. В случае, если Реселлер заберёт свой товар в течение 48 часов с момента готовности заказа к выдаче, заказ получит статус «Заказ готов к выдаче».</p>
<p><b>Важно:</b></p>
<ul>
  <li>С момента получения статуса «Заказ готов к выдаче», у Реселлера будет 48 часов на то, чтобы забрать товар и вернуть его, либо отменить заказ. В случае, если Реселлер вернёт товар в течение 48 часов или отменит заказ, сделка завершится автоматически, товар не будет выдан Реселлеру и будет храниться в пункте выдачи и аутентификации в соответствии с «Правилами хранения Товара».</li>
  <li>Если Реселлер не заберёт свой товар, не осуществит возврат товара или не отменит заказ в течение 48 часов с момента получения статуса заказа «Заказ готов к выдаче», сделка завершится автоматически, а деньги поступят Селлеру. Такая сделка будет считаться успешно завершённой.</li>
</ul>
<p>2.5. Может ли Реселлер отменить заказ и что делать в таком случае:</p>
<p>2.5.1. Реселлер имеет право отказаться от покупки товара на этапе:</p>
<ul>
  <li>Подтверждения Селлером заявки</li>
  <li>После подтверждения Селлером заявки до момента оплаты заказа</li>
  <li>В момент оплаты заказа</li>
  <li>В течение 15 минут с момента оплаты заказа</li>
</ul>
<p>2.5.2. Если Реселлер отменил заказ после получения им статуса «Заказ готов к выдаче», Селлер должен забрать товар по данному заказу из пункта выдачи и аутентификации.</p>
<p>2.6. Что такое аутентификация и зачем она нужна:</p>
<p>2.6.1. Аутентификация - это обязательная проверка товара Селлера на подлинность и соответствие описанию экспертами Платформы. Аутентификация необходима для того, чтобы Реселлеры получали только оригинальные (подлинные) товары.</p>
<p>2.7. Сколько длится аутентификация:</p>
<p>Обычно аутентификация длится до 24 часов после поступления товара по заказу в пункт выдачи и аутентификации Платформы, но обычно гораздо быстрее.</p>
<p>2.7.1. Что будет, если товар не пройдёт аутентификацию:</p>
<p>В случае, если товар Селлера не пройдёт аутентификацию, сделка отменится Платформой, товар будет возвращён Селлеру а деньги, «замороженные» (захолдированные) сервисом ЮКасса, вернутся обратно Реселлеру в полном объёме.</p>
<p>2.7.2. В случае, если товар не прошёл аутентификаю, Селлер обязан оплатить услугу аутентификации Платформы в размере 15% от стоимости заказа.</p>
<p><b>Важно:</b> В случае, если товар Селлера не пройдёт аутентификацию неоднократно, аккаунт Селлера на платформе будет заблокирован.</p>
<p>2.8. Вознаграждение за пользование Платформой и её услугами для Селлера:</p>
<p>Платформа удерживает с Селлера вознаграждение в размере 15% от суммы успешно завершённой сделки.</p>
<p>2.6. Как Селлеру получить деньги за продажу товара:</p>
<p>2.6.1. Селлер получает деньги на банковскую карту — Visa, Mastercard, Мир или любую другую, которую он привязывает в своём личном кабинете. Для этого нужны только данные его карты (владелец карты должен быть резидентом РФ). Денежные средства зачисляются в течение 1-2 рабочих дней.</p>
<p><b>Важно:</b> Селлер несёт полную ответственность за достоверность сведений привязанной им банковской карты, её исправность и законность владения. Селлер также полностью отвечает за налогообложение, если таковое возникает. Платформа не несёт ответственность за достоверность сведений привязанной Селлером банковской карты и не хранит данные банковских карт.</p>
          `,
        },
        {
          id: 3,
          title: "3. Как Реселлеру покупать товары на Платформе",
          body: `
<p>3.1. Откройте каталог товаров на Платформе.</p>
<p>3.2. Выберите нужный вам товар из каталога.</p>
<p>3.3. Внимательно ознакомьтесь с характеристиками в карточке Товара, правилами возврата, сроком доставки (получения) товара, выберите размер, количество и создайте заявку.</p>
<p>3.4. Если на товар Селлера предусмотрен торг, вы можете предложить свою цену за этот товар. Если вы хотите купить несколько товаров в одном заказе, вы должны предложить цену за все товары сразу, либо создавать отдельную заявку на каждый товар, за который хотите поторговаться.</p>
<p>3.5. Предложите свою цену за товар (если Селлер предоставляет возможность торга).</p>
<p>3.6. Отправьте Селлеру заявку на заказ.</p>
<p>3.7. Дождитесь, пока Селлер примет заявку на покупку товара, на это у него есть 60 минут. В случае, если Селлер проигнорировал вашу заявку, она автоматически отменится Платформой. Селлер также может отменить заявку в течение 60 минут в случаях, если:</p>
<ul>
  <li>Выбранных товаров (одного или нескольких) нет в наличии.</li>
  <li>Если Селлер не успевает доставить товар по заказу в пункт выдачи и аутентификации Платформы в течение времени, указанного для доставки.</li>
  <li>Если Селлеру не подходит цена, предложенная Реселлером для покупки.</li>
  <li>По иным причинам.</li>
</ul>
<p>3.7.1. Если Селлер отменит заявку по причине того, что товара нет в наличии, либо по иным причинам, сделка автоматически отменится Платформой.</p>
<p>3.7.2. Если Селлеру не подошла предложенная Реселлером цена, Селлер вправе отменить заявку на заказ. В таком случае Реселлер получит уведомление о том, что предложенная Селлеру цена ему не подходит. В случае, если Селлер хочет предложить Реселлеру свою цену, Реселлер получит уведомление о том, какую цену предлагает Селлер. Если Реселлеру не подходит цена, предложенная Селлером, Реселлер обязан отменить заявку и создать новую.</p>
<p><b>Важно:</b> на Платформе действует правило – «один Селлер – одна сделка». То есть для каждого Селлера нужно будет создать отдельную заявку.</p>
<p>3.7.3. В случае, если Селлер понимает, что не успевает доставить товар в пункт выдачи и аутентификации в течение времени, указанного им на доставку товара в пункт выдачи и аутентификации, Селлер имеет право продлить срок доставки товара по заказу. В таком случае Реселлеру придёт уведомление о том, что Селлер запросил увеличение времени доставки товара по заказу в пункт выдачи и аутентификации.</p>
<p><b>Важно:</b> Реселлер имеет право отклонить запрос на продление времени доставки. В таком случае нужно будет отклонить запрос Селлера на продление срока доставки товара и создать новую заявку. Если Реселлер согласится на продление срока доставки, оформление заказа продолжится.</p>
<p>3.7.4. После того, как заявка будет подтверждена Селлером, у Реселлера есть 30 минут для того, чтобы перейти к оплате заказа, получив ссылку на оплату. Если Реселлер в течение 30 минут с момента подтверждения заявки Селлером не перейдёт к оплате заказа, сделка автоматически отменится Платформой, а Реселлеру нужно будет создать новую заявку.</p>
<p>После того, как Реселлер оплатит заказ, у него есть 15 минут на отмену оплаты. Если Реселлеру нужно отменить оплату, он незамедлительно обязан обратиться в техническую поддержку Платформы с запросом на отмену оплаты. По истечению 15 минут с момента оплаты, если Реселлер не успевает обратиться в службу поддержки Платформы, отменить оплату будет невозможно. Временем на отмену оплаты считается время с момента оплаты заказа до получения технической поддержкой Платформы запроса на отмену оплаты.</p>
<p>3.7.5. Денежные средства Реселлера «заморозятся» (захолдируются) на счёте сервиса ЮКасса.</p>
<p>3.7.6. В случае, если Реселлер оплатил заказ и не отменил оплату, Селлер получит уведомление о том, что ему нужно доставить товар по заказу в течение времени, указанного им при регистрации и отображённом в заявке. Селлер обязан доставить товар по заказу в пункт выдачи и аутентификации Платформы для аутентификации товара по заказу.</p>
<p>3.7.7. После того, как товар прибудет в пункт выдачи и аутентификации Платформы, а аутентификацию будет начата, Реселлеру поступит уведомление о том, что заказ находится в пункте выдачи и аутентификации и аутентификация начата.</p>
<p>3.7.8. В случае прохождения товаром аутентификации, Реселлеру поступит уведомление о том, что заказ готов к выдаче. Реселлер должен самостоятельно забрать товар по заказу из пункта выдачи и аутентификации по адресу: Московская область, Ленинский городской округ, Варшавское шоссе, 21-й километр, с26, помещение АД 14А.</p>
<p>3.7.9. После того, как Реселлер получит уведомление о том, что заказ готов к выдаче, у Реселлера будет 48 часов, чтобы забрать и вернуть товар по заказу в случае необходимости. Таймер подскажет количество оставшегося времени.</p>
<p>3.8. Условия отмены заказа Реселлером:</p>
<p>3.8.1. Реселлер имеет право отменить заказ на следующих этапах сделки:</p>
<ul>
  <li>В течение времени на подтверждение заявки Селлером</li>
  <li>После подтверждения заявки Селлером до момента оплаты</li>
  <li>В течение 15 минут с момента оплаты.</li>
  <li>После получения Статуса, что заказ готов к выдаче.</li>
</ul>
<p><b>Важно:</b> При отмене заказа в течение 48 часов после того, как Реселлер получил уведомление о том, что заказ готов к выдаче, сделка автоматически завершится Платформой, деньги за заказ вернутся Реселлеру, а Платформой с Реселлера взимется вознаграждение за услугу аутентификации товара в размере 15% от стоимости заказа. Денежные средства вернутся Реселлеру с учётом вознаграждения Платформы.</p>
<p>3.9. Условия возврата товара по заказу:</p>
<p>3.9.1. Возврат товара возможен в следующих случаях, если:</p>
<ul>
  <li>Возврат предусмотрен Селлером.</li>
  <li>При осмотре в момент получения обнаружено расхождение с заказанным Товаром;</li>
  <li>Отсутствуют следы носки, повреждения.</li>
  <li>Не нарушена целостность защитной пломбы и сертификат аутентификации, принадлежащий данному товару, имеется в наличии.</li>
  <li>В наличии имеется весь комплект дополнительных аксессуаров, если таковые имеются у товара изначально.</li>
  <li>Не нарушен срок возврата.</li>
</ul>
<p><b>Важно:</b> По истечению времени на возврат товара по заказу, после его выдачи Реселлеру, сделка завершится автоматически, оплата за заказ перечислится Селлеру, а возврат товара будет невозможен.</p>
<p>3.10. Что будет, если Реселлер не успел отменить, забрать и/или вернуть товар по заказу в течение 48 часов с момента получения Статуса, что заказ готов к выдаче:</p>
<p>3.10.1. В случае, если по истечению 48 часов с момента уведомления Реселлера о том, что заказ готов к выдаче, Реселлер, не отменил, не забрал и/или не вернул товар по заказу, сделка считается завершённой, деньги за товар по заказу будут перечислены Селлеру в полном объёме. Возврат товара будет невозможен.</p>
<p>3.10.2. В случае, если Реселлер не отменил, не забрал и/или не вернул товар по заказу, товар по заказу хранится в пункте выдачи и аутентификации в соответствии с «Правилами хранения товара».</p>
          `,
        },
        {
          id: 4,
          title: "4. Как отследить процесс сделки",
          body: `
<p>4.1. Процесс сделки отслеживаются в личном кабинете пользователя путём статусов, а также с помощью уведомлений Платформы.</p>
          `,
        },
        {
          id: 5,
          title: "5. Какими способами оплаты можно оплатить заказ",
          body: `
<p>5.1. Заказ можно оплатить банковской картой, а также через СБП, ЮMoney и другими способами. С полным перечнем способов оплаты вы можете ознакомиться на сайте: <a href="https://yookassa.ru/docs/support/payments/accept-methods" target="_blank">https://yookassa.ru/docs/support/payments/accept-methods</a></p>
          `,
        },
        {
          id: 6,
          title: "6. Что такое «торг» и как это работает",
          body: `
<p>6.1. На платформе предусмотрена возможность торга за товары Селлеров.</p>
<p>6.2. Реселлеры могут предлагать свою цену за товар. Селлеры могут включать эту опцию по своему усмотрению. Также по своему усмотрению Селлер вправе отказаться от цены, предложенной Реселлером и продавать свой товар по заранее установленной цене.</p>
<p><b>Важно:</b> возможность торга даёт Селлеру больше возможностей продать свой товар, а Реселлеру купить его по наиболее выгодной для него цене.</p>
<p>6.3. Для того, чтобы торговаться за товар, Реселлеру необходимо предложить свою цену за товар при создании заявки путём выбора опции торга.</p>
<p>6.4. Если Селлера устроит предложенная Реселлером цена, начнётся процесс оформления заказа.</p>
<p>6.5. Селлер вправе отказаться от предложенной Реселлером цены.</p>
<p>6.6. Селлер имеет право предложить свою цену в ответ, а Реселлер имеет право отклонить её. В таком случае Реселлеру нужно будет создать заявку с новой ценой, либо отменить заявку.</p>
          `,
        },
        {
          id: 7,
          title: "7. Что такое безопасная сделка и как она работает",
          body: `
<p>7.1. Подробнее с условиями услуги «Безопасная сделка» можно ознакомиться на сайте:</p>
<p><a href="https://yookassa.ru/docs/support/safe-deal/work" target="_blank">https://yookassa.ru/docs/support/safe-deal/work</a></p>
          `,
        },
        {
          id: 8,
          title: "8. Безопасно ли указывать данные карты",
          body: `
<p>8.1. Все платежи обрабатываются через защищенные платежные шлюзы. Платформа не хранит данные банковских карт.</p>
          `,
        },
        {
          id: 9,
          title: "9. Как пожаловаться на Селлера или Реселлера",
          body: `
<p>9.1. Необходимо обратиться в техническую поддержку Платформы. Мы разберемся в ситуации и примем меры.</p>
          `,
        },
        {
          id: 10,
          title: "10. Как связаться с поддержкой",
          body: `
<p>10.1. Связаться с технической поддержкой Платформы можно через личный кабинет. Время ответа до 24 часов.</p>
          `,
        },
        {
          id: 11,
          title: "11. Ответственность Селлера и Реселлера",
          body: `
<p>11.1. Селлеры и Реселлеры несут полную самостоятельную ответственность за все действия на Платформе. Любые противоправные действия на Платформе запрещены Участниками в любом виде.</p>
<p>11.2. Запрещен сговор. Любые попытки манипулирования ценами, искусственного завышения или занижения стоимости в сговоре с другими пользователями строго запрещены.</p>
<p>11.3. Запрещен обман. Введение других пользователей в заблуждение, мошеннические схемы. Попытки обойти правила Платформы недопустимы.</p>
<p>11.4. Запрещено размещение на Платформе информации о поддельных (неоригинальных) товарах.</p>
<p>11.5. Все товарные знаки (логотипы, эмблемы), представленные на Платформе, являются зарегистрированными товарными знаками и принадлежат правообладателям. Селлерам и Реселлерам запрещено использовать зарегистрированные товарные знаки (логотипы, эмблемы) без разрешения правообладателей, либо без иных законных оснований.</p>
<p>11.6. Селлеры и Реселлеры обязаны уважать друг друга. Запрещены оскорбления, угрозы, дискриминационные высказывания в любом виде.</p>
<p>11.7. Во всех своих действия на Платформе Селлеры и Реселлеры несут ответственность в соответствии с действующим Законодательством Российской Федерации.</p>
<p>11.8. Селлеры и Реселлеры подтверждают, что ознакомлены и полностью и безоговорочно согласны с Правилами Платформы и настоящим FAQ.</p>
<p>11.9. Платформа имеет право изменять данный FAQ по своему усмотрению в одностороннем порядке без личного уведомления Селлеров или Реселлеров.</p>
<p>11.10. Селлеры и Реселлеры подтверждают, что проинформированы об изменениях путём посещения интернет-ресурса Платформы, а также любым действием, совершённым на Платформе.</p>
          `,
        },
      ],
    }
  },
  computed: {
    filteredFaqs() {
      const q = this.search.trim().toLowerCase()
      if (!q) return this.faqs
      return this.faqs.filter((item) =>
        (item.title + " " + item.body).toLowerCase().includes(q)
      )
    },
  },
  methods: {
    applyRouteOpen() {
      const openId = this.$route.query.openId
      if (!openId) return
      // При открытии по ссылке снимаем фильтр, чтобы элемент был виден
      this.search = ""
      const parsedId = Number(openId)
      const targetId = Number.isNaN(parsedId) ? openId : parsedId
      // Проверяем, что вопрос существует
      const exists = this.faqs.some((f) => f.id === targetId)
      if (!exists) return
      this.openedId = targetId
      this.$nextTick(() => {
        this.scrollTo(targetId)
      })
    },
    scrollTo(id) {
      const refEl = this.$refs[`faq-${id}`]
      const el = Array.isArray(refEl) ? refEl[0] : refEl
      if (!el) return

      // Смещаем на 60px выше, чтобы блок оказался под хедером
      const headerOffset = 60
      const rect = el.getBoundingClientRect()
      const absoluteTop = rect.top + window.scrollY
      const target = absoluteTop - headerOffset

      window.scrollTo({
        top: target,
        behavior: "smooth",
      })
    },
    toggle(id) {
      this.openedId = this.openedId === id ? null : id
    },
    isOpen(id) {
      return this.openedId === id
    },
  },
  watch: {
    "$route.query.openId": {
      handler() {
        this.applyRouteOpen()
      },
      immediate: true,
    },
  },
  mounted() {
    this.applyRouteOpen()
  },
}
</script>

<style lang="scss" module>
.wrapper {
  padding: 0 1rem 7rem 1rem;
  min-height: 100vh;
}

.search {
  position: relative;
  margin-bottom: 1rem;
}

.searchInput {
  width: -webkit-fill-available;
  border-radius: 0.5rem;
  border: 1px solid #ececee;
  background: transparent;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  outline: none;
}

.searchInput::placeholder {
  color: #808080;
}

.searchIcon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #1c1c1e;
}

.list {
  display: grid;
  gap: 0.625rem;
}

.card {
  border-radius: 0.5rem;
  background: #f5f7fa;
  padding: 1rem;
}

.cardHeader {
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.question {
  font-size: 1rem;
  font-weight: 400;
  text-align: left;
  color: #000000;
  padding-right: 0.5rem;
}

.chevron {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0a0a5;
  transition: transform 0.2s ease;
}

.chevronOpen {
  transform: rotate(180deg);
}

.answer {
  margin-top: 1rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #00000080;
}
/* Пустой результат */
.empty {
  margin-top: 1rem;
  font-size: 0.875rem;
  color: #9b9ba1;
  text-align: center;
}
</style>

<style lang="scss">
/* Анимация */
.faq-enter-active,
.faq-leave-active {
  max-height: 500px;
  transition: all 0.18s ease;
}

.faq-enter-from,
.faq-leave-to {
  opacity: 0;
  max-height: 0;
}
</style>
